import { render, staticRenderFns } from "./Grid3OLBDoughnut.vue?vue&type=template&id=d2106556"
import script from "./Grid3OLBDoughnut.vue?vue&type=script&lang=js"
export * from "./Grid3OLBDoughnut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports